import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_SYSTEM_CODES_QUERY } from "../../graphql/SystemCodes/SystemCodes.graphql";

function CurrencySelect({ value, label, size, name, icon, onChange }) {
  const { data, loading, error } = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: { where: { Category: "Company", CodeName: "Currency" } }
  });
  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={error ? "danger" : ""}
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select name={name} value={value} onChange={onChange}>
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data.SystemCodes.map((code, i) => (
                <Select.Option key={`currency-select-${i}`} value={code.RecId}>
                  {code.CodeDescription}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

CurrencySelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  onChange: PropTypes.func
};

CurrencySelect.defaultProps = {
  icon: "money-bill"
};
export default CurrencySelect;
